// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const env = (k, fallback) => process.env[k] || fallback;

const firebaseConfig = {
  apiKey:            env('REACT_APP_FIREBASE_API_KEY', env('REACT_APP_API_KEY')),
  authDomain:        env('REACT_APP_FIREBASE_AUTH_DOMAIN', env('REACT_APP_AUTH_DOMAIN')),
  databaseURL:       env('REACT_APP_FIREBASE_DATABASE_URL', env('REACT_APP_DATABASE_URL')),
  projectId:         env('REACT_APP_FIREBASE_PROJECT_ID', env('REACT_APP_PROJECT_ID')),
  storageBucket:     env('REACT_APP_FIREBASE_STORAGE_BUCKET', env('REACT_APP_STORAGE_BUCKET')),
  messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID', env('REACT_APP_MESSAGING_SENDER_ID')),
  appId:             env('REACT_APP_FIREBASE_APP_ID', env('REACT_APP_APP_ID')),
};

const app = initializeApp(firebaseConfig);

export const auth     = getAuth(app);
export const db       = getFirestore(app);
export const database = getDatabase(app);
export const storage  = getStorage(app);

export { app };
